// extracted by mini-css-extract-plugin
module.exports = {"buttonLikeRadioGroup":"button-like-radio-group_component_buttonLikeRadioGroup__Y_NwC"};